import { FormPost } from '../../core';
import { EvalFormValue } from '../model/eval-form-value.model';

export function evaluationFormPostTransformer(
    evalForm: EvalFormValue,
): FormPost {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        templateVersionId: evalForm.templateVersionId,
        userId: evalForm.userId,
        targetUserId: evalForm.targetUserId,
        eventDate: evalForm.eventDate,
        contactLength: evalForm.contactLength,
        queue: evalForm.queue,
        groups: evalForm?.groups?.map((g) => ({
            groupId: g.groupId,
            sections: g.sections?.map((s) => ({
                sectionId: s.sectionId,
                responses: s.questions?.map((q) => ({
                    questionId: q.questionId,
                    optionValue: q.optionId,
                    optionReasonValue: q.optionReasonValue,
                    boolValue: q.boolValue,
                    textValue: q.textValue,
                })),
            })),
        })),
        comments: evalForm?.comments?.map((e) => ({ text: e })),
    } as FormPost;
}
